import { mapGetters, mapActions } from 'vuex';
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {customerTypesOptions} from '../config/index';
/**
 * 需要页面组件自己注入或重写参数
 * listData: 页面列表数据 导入名字key需重命名为listData
 * pagination: 列表的分页数据
 * filters: 带有搜索条件的页面需自己定义filters
 *
 * 需要页面组件自己注入或重写方法
 * fetchList: 获取列表数据的方法 通常为触发action的方法
 * updatePagination: 切换分页大小需要注入此方法更新分页信息
 */
export default {
  data() {
    return {
      // listData: [], // 需页面组件自己注入列表并命名为 listData
      needCreatedFetch: true,
      filters: {},
      selected: {},
      selectedList: [], // 带有选择框列表选中的列表项
      editType: 0, // 带有新增/编辑的页面区分编辑状态
      dialogEditVisible: false, // 带有新增/编辑的页面弹出框可/不可见
      dialogDetailVisible: false, // 详情弹窗
      customerTypesOptions:customerTypesOptions
    };
  },
  //
  computed: {
    ...mapGetters(['loading', 'routeNames']),
  },
  created() {
    // 当页面没有打开过的时候调用
    if (this.routeNames.find(name => name === this.$route.name)) return;
    this.updateRouteNames(this.$route.name);
    if (this.needCreatedFetch) {
      this.fetchList({
        pageNum: 1,
      });
    }
  },
  mounted(){
    if(this.$refs.paginationExport){
      this.$refs.paginationExport.$children[0].pageSizes = [10,30,50,100,300,500,1000,2000]
    }
  },
  methods: {
    ...mapActions(['updateRouteNames']),
    // 页面组件需自己实现获取列表数据的方法
    fetchList() {},
    // 点击搜索时处理函数
    searchList() {
      this.changePage(1);
    },
    // 获取过滤条件方法 组件可自己实现
    getFilters() {
      let { timeRange, ...filters } = this.$getFilters(this.filters);
      if (timeRange) {
        const [starttime, endtime] = timeRange;
        if (starttime) filters.starttime = starttime;
        if (endtime) filters.endtime = endtime;
      }
      return filters;
    },
    // 获取名称方法
    getNameUtil(val, list = [], keyName = 'label', valueName = 'value') {
      let item = list.find(item => item[valueName] === val);
      return item ? item[keyName] : val;
    },
    // 页码改变时处理函数
    changePage(index = 1) {
      const filters = this.getFilters();
      this.fetchList({
        ...filters,
        pageNum: index,
      });
    },
    // 分页大小改变时处理函数
    changeSizeHandle(pageSize) {
      const filters = this.getFilters();
      this.fetchList({
        ...filters,
        pageNum: 1,
        pageSize: pageSize,
      });
      this.updatePagination({
        pageNum: 1,
        pageSize: pageSize,
      });
    },
    // 当列表可选时 处理选择函数
    handleSelectionChange(val) {
      this.selectedList = val;
    },
    resetEditDialog(done) {
      if (typeof this.initSelected === 'function') {
        this.selected = this.initSelected();
      } else {
        this.selected = {};
      }
      done && typeof done == 'function'
        ? done()
        : (this.dialogEditVisible = false);
    },
    resetDetailDialog(done) {
      if (typeof this.initSelected === 'function') {
        this.selected = this.initSelected();
      } else {
        this.selected = {};
      }
      done && typeof done == 'function'
        ? done()
        : (this.dialogEditVisible = false);
    },
    export2Excel(excelName='未命名') {
      var fix = document.querySelector('.el-table__fixed');
      var wb;
      if (fix&&excelName!='注册结果') {
        wb = XLSX.utils.table_to_book(document.querySelector('.exportTable').removeChild(fix));
        document.querySelector('.exportTable').appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(document.querySelector('.exportTable'));
      }
      let wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          excelName + '.xlsx'
        );
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout);
      }
      return wbout;
    },
  },
};
